/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_SourcesInputs */

const en_gc_guides_sources = /** @type {(inputs: Gc_Guides_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources and version notes`)
};

const zh_gc_guides_sources = /** @type {(inputs: Gc_Guides_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源与版本说明`)
};

/**
* | output |
* | --- |
* | "Sources and version notes" |
*
* @param {Gc_Guides_SourcesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_sources = /** @type {((inputs?: Gc_Guides_SourcesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_SourcesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_sources(inputs)
	return zh_gc_guides_sources(inputs)
});
export { gc_guides_sources as "gc.guides.sources" }